import {findLast} from 'ramda';

export const getSlugFromUri = uri => {
  const url = new URL(uri);
  return findLast(p => p !== '', url.pathname.split('/'));
};
